import { ProductTranslationModel } from '../../../../pages/products/edit/components/translationsCard/translationsCard.model'
import { getActiveCompany } from '../../../../redux'
import { ProductConceptModel, ProductModel } from '../../model/contracts'
import {
  ProductConceptRequest,
  ProductTranslationRequest,
  UpdateProductRequest
} from './model/products.request.model'

export const mapProductModelToUpdateProductRequest = (
  product: ProductModel
): UpdateProductRequest => {
  const activeCompany = getActiveCompany()?.id
  let mappedTranslations: ProductTranslationRequest[] | [] = []
  let mappedRelatedConcepts: ProductConceptRequest[] | [] = []

  // map translations
  if (product.translations) {
    mappedTranslations = product.translations.map((t: ProductTranslationModel) => {
      return {
        ...(t.id !== undefined && { id: t.id }),
        language: t.language,
        description: t.description,
        ...(t.default !== undefined && { default: t.default })
      }
    })
  }

  //map concepts
  if (product.relatedConcepts) {
    mappedRelatedConcepts = product.relatedConcepts.map((c: ProductConceptModel) => {
      return {
        id: c.id,
        conceptId: c.conceptId,
        productId: c.productId ? c.productId : product.id!,
        conceptType: c.conceptType,
        calculationType: c.calculationType,
        startDate: c.startDate,
        ...(c.endDate !== undefined && { endDate: c.endDate }),
        required: c.required,
        relationType: c.relationType,
        conditionType: c.conditionType
      }
    })
  }

  const mappedProduct: UpdateProductRequest = {
    id: product.id,
    code: product.code,
    description: product.description,
    type: product.type,
    currency: product.currency,
    commodity: product.commodity,
    companyId: activeCompany,
    breakdownType: product.breakdownType,
    weightedType: product.weightedType,
    translations: product.translations ? mappedTranslations : [],
    relatedConcepts: product.relatedConcepts ? mappedRelatedConcepts : [], // ProductConceptRequest[]
    lgEnabled: product.lgEnabled
  }

  return mappedProduct
}
